if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        const allowGiftProps = this.dataset.showGiftItem === "true";
        const sectionId = this.dataset.sectionId;
        const container = sectionId ? document.getElementById(`MainProduct-${sectionId}`) : document;
        const productScope = this.closest("product-info") || container || document;
        const freeInputs = allowGiftProps ? productScope.querySelectorAll('input[data-item="free"]:checked') : [];
        if (allowGiftProps && freeInputs.length > 0) {
          freeInputs.forEach((input, index) => {
            let title = input.getAttribute('data-title');
            if (!title) {
               // Fallback if data-title isn't present
               const container = input.closest('.free-product-item-row');
               const titleEl = container ? container.querySelector('.item-title h4') : null;
               title = titleEl ? titleEl.innerText.trim() : `Free Gift ${index + 1}`;
            }
            // Append as readable property
            formData.append(`properties[Free Gift ${index + 1}]`, title);
            // Append internal ID if needed (hidden by default theme logic usually)
            formData.append(`properties[_FreeGiftVariantId ${index + 1}]`, input.value);
          });
        }

        const selectedUpsellVariantIds = [];
        const seenUpsellVariantIds = new Set();
        productScope.querySelectorAll('input[data-item="upsell"]:checked').forEach((input) => {
          const item = input.closest(".upsell-product-item");
          const variantSelect = item?.querySelector(".upsell-variant-select");
          const variantId = Number(variantSelect?.value || input.value);

          if (!Number.isInteger(variantId) || variantId <= 0 || seenUpsellVariantIds.has(variantId)) return;

          seenUpsellVariantIds.add(variantId);
          selectedUpsellVariantIds.push(variantId);
        });

        const mainVariantId = Number(formData.get("id"));
        const mainQuantity = Math.max(1, Number(formData.get("quantity")) || 1);

        if (selectedUpsellVariantIds.length > 0) {
          const properties = {};
          formData.forEach((value, key) => {
            const propertyMatch = key.match(/^properties\[(.+)]$/);
            if (propertyMatch && value !== "") properties[propertyMatch[1]] = value;
          });

          const mainItem = {
            id: mainVariantId,
            quantity: mainQuantity,
          };
          const sellingPlan = Number(formData.get("selling_plan"));

          if (Object.keys(properties).length > 0) mainItem.properties = properties;
          if (Number.isInteger(sellingPlan) && sellingPlan > 0) mainItem.selling_plan = sellingPlan;

          const payload = {
            items: [
              mainItem,
              ...selectedUpsellVariantIds.map((variantId) => ({
                id: variantId,
                quantity: 1,
              })),
            ],
          };

          if (this.cart) {
            payload.sections = this.cart.getSectionsToRender().map((section) => section.id).join(",");
            payload.sections_url = window.location.pathname;
          }

          config.headers["Content-Type"] = "application/json";
          config.body = JSON.stringify(payload);
        } else {
          config.body = formData;
        }
        
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (Array.isArray(response.items)) {
              const mainItemResponse =
                response.items.find((item) => item.variant_id === mainVariantId) || response.items[0];

              if (mainItemResponse) {
                response.key = mainItemResponse.key;
                response.id = mainItemResponse.id;
                response.product_id = mainItemResponse.product_id;
                response.variant_id = mainItemResponse.variant_id;
              }
            }

            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error)
              this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
